// MultiStepForm.js
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import {
  Container,
  Form,
  Button,
  ProgressBar,
  Nav,
  Alert,
} from "react-bootstrap";
import SignaturePad from "react-signature-canvas"; // Import the SignaturePad component
import "./Signature.css";
import { connect } from "react-redux";
import { getSasToken } from "../../store/thunk/user";
import { updateForm } from "../../utils/updateForm";
import { uploadDocumentAndGetUrl } from "../../utils/uploadDocument";
import { dataURLtoBlob } from "../../utils/dataURLtoBlob";
import { triggerButtonClick } from "../../utils/triggerLibraryButton";
import { toast } from "react-toastify";
import LfukKidForPayeDownload from "./Download/LfukKidForPayeDownload";
import { Tabs, Tab, Box } from "@mui/material";
import moment from "moment";

const LfukKidForPaye = ({
  currentDocument,
  documentList,
  user,
  sasToken,
  ipAddress,
  getSasToken,
}) => {
  const [step, setStep] = useState(1);
  const [progress, setProgress] = useState(0); // Progress percentage for each step
  const [value, setValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const [formData, setFormData] = useState({
    title: "",
    firstName: "",
    surName: "",
    documentSignature: "",
    signedDate: "",
    consent: false,
    signature: "", // Store the signature data as a string
  });
  const [errors, setErrors] = useState({});
  const sigPadRef = useRef(null); // Reference to the SignaturePad component
  const documentSigPadRef = useRef(null); // Reference to the SignaturePad component
  useEffect(() => {
    setFormData(currentDocument);
    if (currentDocument?.step) {
      setStep(currentDocument?.step);
    }
    if (currentDocument?.progress) {
      setProgress(currentDocument?.progress);
    }
    if (currentDocument?.progress === 100) {
      getSasToken();
    }
  }, []);
  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
    setErrors({ ...errors, [name]: "" });
  };

  // Function to validate each step
  const validateStep = () => {
    let formErrors = {};
    if (step === 1) {
      if (!formData.title) formErrors.title = "This field is required";
      if (!formData.firstName) formErrors.firstName = "This field is required";
      if (!formData.surName) formErrors.surName = "This field is required";
      if (documentSigPadRef.current.isEmpty()) {
        formErrors.documentSignature = "This field is required"; // Check if the signature pad is empty
      }
    } else if (step === 2) {
      if (!formData.consent) formErrors.consent = "You must agree to the terms";
      if (sigPadRef.current.isEmpty())
        formErrors.signature = "Signature is required"; // Check if the signature pad is empty
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  // Function to go to the next step
  const nextStep = async () => {
    if (validateStep()) {
      const documentSignatureImage = documentSigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      const signatureBlob = dataURLtoBlob(documentSignatureImage);
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            documentSignature: documentUrl,
            progress: progress + 50,
            step: step + 1,
          },
        };
        updateForm(payload, documentList, user);
        setStep(step + 1);
        setProgress(progress + 50);
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
    }
  };

  // Function to go to the previous step
  const prevStep = () => {
    setStep(step - 1);
    setProgress(progress - 50);
  };

  // Function to handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateStep()) {
      // Get the signature data as a base64 image
      const signatureImage = sigPadRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormData({
        ...formData,
        signature: signatureImage,
      });
      const signatureBlob = dataURLtoBlob(signatureImage);
      // Create a FormData object
      const formDataSign = new FormData();
      // Append the Blob as a file to the FormData
      // The second argument is the file name, which you can customize as needed
      formDataSign.append(
        "file",
        signatureBlob,
        `${[currentDocument["key"]]}.png`
      );
      // Send the FormData using postMultiPartFormData
      const documentUrl =
        (await uploadDocumentAndGetUrl(formDataSign, user?.token)) || "";
      if (documentUrl) {
        const payload = {
          [currentDocument["key"]]: {
            name: currentDocument?.name,
            ...formData,
            progress: 100,
            step: step,
            signature: documentUrl,
            signDate: new Date(),
            ipAddress: ipAddress,
          },
        };
        updateForm(payload, documentList, user);
        toast.success("Successfully filled the form.");
        triggerButtonClick();
      } else {
        toast.error(
          "Something went wrong while upload signature. please try again."
        );
      }
      // Additional submit logic here, such as sending formData to the server
    }
  };
  // Clear the signature pad
  const clearSignature = () => {
    sigPadRef.current.clear();
    setFormData({ ...formData, signature: "" });
  };
  // Clear the signature pad
  const clearDocumentSignature = () => {
    documentSigPadRef.current.clear();
    setFormData({ ...formData, documentSignature: "" });
  };
  return (
    <Container className="mt-5">
      {currentDocument?.progress === 100 ? (
        <>
          <LfukKidForPayeDownload data={currentDocument} sasToken={sasToken} user={documentList?.userDetail} />
          <Box sx={{ width: "100%" }}>
            <Tabs
              value={value}
              onChange={handleTabChange}
              aria-label="Personal Information"
              className="tab mt-2"
            >
              <Tab label="Personal Information" />
            </Tabs>
            {value === 0 && (
              <div className="container">
                <div className="row">
                  <h2>Personal Information</h2>
                  <ul class="list-group">
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>Title</strong>{" "}
                      <span>{currentDocument?.title || "--"}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>First Name</strong>{" "}
                      <span>{currentDocument?.firstName || "--"}</span>
                    </li>
                    <li class="list-group-item d-flex justify-content-between">
                      <strong>Surname</strong>{" "}
                      <span>{currentDocument?.surName || "--"}</span>
                    </li>
                    <li
                      class="list-group-item d-flex"
                      style={{ textAlign: "justify" }}
                    >
                      <strong>
                        Rapid Resourcing Ltd, Storage House c/o Henry Diaper,
                        Lees Road, Knowsley Industrial Estate, Liverpool, L33 7SE
                        KEY INFORMATION DOCUMENT This document sets out key
                        information about your relationship with us, including
                        details about pay, holiday entitlement and other benefits.
                        For further information, please contact Rapid Resourcing Limited at admin@rapidresourcingltd.co.uk. The
                        Employment Agency Standards (EAS) Inspectorate is the
                        government authority responsible for the enforcement of
                        certain agency worker rights. You can raise a concern with
                        them directly on 020 7215 5000 or through the Acas helpline
                        on 0300 123 1100, Monday to Friday, 8am to 6pm. GENERAL
                        INFORMATION Your name: Name of employment business: Rapid
                        Resourcing Ltd Your employer (if different from the
                        employment business): N/A Type of contract you will be
                        engaged under: Contract for Services Who will be
                        responsible for paying you (if different from your employer):
                        N/A How often you will be paid: Weekly Expected or minimum
                        rate of pay: National Minimum Wage or National Living Wage
                        (whichever applicable) Deductions from your pay required by
                        law: Income Tax, National Insurance Student Loans (if
                        Applicable) Court Orders & Child Maintenance (if applicable)
                        Employee Pension Contributions (which will be deferred for
                        the first 12 weeks then automatically enrolled subject to
                        qualifying criteria, opt out is permitted) Any other
                        deductions or costs from your pay (to include amounts or how
                        they are calculated): None known at present Any fees for
                        goods or services: None Holiday entitlement and pay: 5.6
                        weeks pro rata (or as otherwise agreed) Paid at an average
                        rate to represent a standard week’s pay Additional
                        benefits: None EXAMPLE PAY Example rate of pay: £12.71 x 36
                        = £457.56 Deductions from your wage required by law: Tax
                        £43.00 EE NI £17.24 EE Pension (if applicable) £13.50 Any
                        other deductions or costs from your wage: None known at
                        present Any fees for goods or services: None Example net
                        take home pay: £457.56 - £43.00 - £17.24 - £13.50 = £383.82
                        <br />
                        FullName: {currentDocument?.firstName}{" "}
                        {currentDocument?.surName}
                      </strong>
                    </li>
                    <li className="list-group-item d-flex">
                      <div className="row">
                        <div className="col-12">
                          {currentDocument?.signature && (
                            <img
                              width={100}
                              src={`${currentDocument?.signature}?${sasToken}`}
                              alt="Signature"
                            />
                          )}
                        </div>
                      </div>
                    </li>
                    <li className="list-group-item d-flex">
                      Sign Date:{" "}
                      {moment(currentDocument?.signDate).format("DD-MM-YYYY")}
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </Box>
        </>
      ) : (
        <>
          <Nav variant="pills" className="justify-content-center mb-3">
            <Nav.Item>
              <Nav.Link
                className={step === 1 ? "text-light" : ""}
                active={step === 1}
              >
                Step 1
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link
                className={step === 2 ? "text-light" : ""}
                active={step === 2}
              >
                Step 2
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <ProgressBar now={progress} className="mb-4" />

          <Form onSubmit={handleSubmit}>
            {step === 1 && (
              <div>
                <h3>Section 1: Personal Information</h3>
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleChange}
                    isInvalid={!!errors.title}
                    required
                  />
                  {errors.title && (
                    <Alert variant="danger">{errors.title}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    isInvalid={!!errors.firstName}
                    required
                  />
                  {errors.firstName && (
                    <Alert variant="danger">{errors.firstName}</Alert>
                  )}
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Surname</Form.Label>
                  <Form.Control
                    type="text"
                    name="surName"
                    value={formData.surName}
                    onChange={handleChange}
                    isInvalid={!!errors.surName}
                    required
                  />
                  {errors.surName && (
                    <Alert variant="danger">{errors.surName}</Alert>
                  )}
                </Form.Group>
                <p style={{ textAlign: "justify" }}>
                  Rapid Resourcing Ltd, Storage House c/o Henry Diaper, Lees
                  Road, Knowsley Industrial Estate, Liverpool, L33 7SE KEY
                  INFORMATION DOCUMENT This document sets out key information
                  about your relationship with us, including details about pay,
                  holiday entitlement and other benefits. For further information,
                  please contact Rapid Resourcing Limited at admin@rapidresourcingltd.co.uk. The Employment Agency Standards (EAS)
                  Inspectorate is the government authority responsible for the
                  enforcement of certain agency worker rights. You can raise a
                  concern with them directly on 020 7215 5000 or through the Acas
                  helpline on 0300 123 1100, Monday to Friday, 8am to 6pm. GENERAL
                  INFORMATION Your name: Name of employment business: Rapid
                  Resourcing Ltd Your employer (if different from the employment
                  business): N/A Type of contract you will be engaged under:
                  Contract for Services Who will be responsible for paying you (if
                  different from your employer): N/A How often you will be paid:
                  Weekly Expected or minimum rate of pay: National Minimum Wage or
                  National Living Wage (whichever applicable) Deductions from your
                  pay required by law: Income Tax, National Insurance Student
                  Loans (if Applicable) Court Orders & Child Maintenance (if
                  applicable) Employee Pension Contributions (which will be
                  deferred for the first 12 weeks then automatically enrolled
                  subject to qualifying criteria, opt out is permitted) Any other
                  deductions or costs from your pay (to include amounts or how
                  they are calculated): None known at present Any fees for goods
                  or services: None Holiday entitlement and pay: 5.6 weeks pro
                  rata (or as otherwise agreed) Paid at an average rate to
                  represent a standard week’s pay Additional benefits: None
                  EXAMPLE PAY Example rate of pay: £12.71 x 36 = £457.56
                  Deductions from your wage required by law: Tax £43.00 EE NI
                  £17.24 EE Pension (if applicable) £13.50 Any other deductions
                  or costs from your wage: None known at present Any fees for
                  goods or services: None Example net take home pay: £457.56 -
                  £43.00 - £17.24 - £13.50 = £383.82
                </p>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="date"
                    name="signedDate"
                    value={formData.signedDate}
                    onChange={handleChange}
                  />
                </Form.Group>{" "}
                <Form.Group className="mb-3">
                  <Form.Label>Signed</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={documentSigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.documentSignature && (
                    <Alert variant="danger">{errors.documentSignature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearDocumentSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Button variant="primary" onClick={nextStep}>
                  Next
                </Button>
              </div>
            )}
            {step === 2 && (
              <div>
                <h3>Step 2: Sign and Submit</h3>
                <p>
                  By signing this page, I confirm that I fully understand the
                  content and agree to adhere to it at all times. I also agree
                  that all the details provided in this document are accurate
                  and complete to the best of my knowledge.
                </p>
                {/* Signature Pad Section */}
                <Form.Group className="mb-3">
                  <Form.Label>Signature</Form.Label>
                  <div className="signature-pad">
                    <SignaturePad
                      ref={sigPadRef}
                      penColor="black"
                      canvasProps={{ className: "signature-canvas" }} // Customize the canvas appearance
                    />
                  </div>
                  {errors.signature && (
                    <Alert variant="danger">{errors.signature}</Alert>
                  )}
                  <Button
                    variant="secondary"
                    onClick={clearSignature}
                    className="mt-2"
                  >
                    Clear Signature
                  </Button>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    name="consent"
                    label="Clear By ticking this box I consent to the company processing my
                data and the evidence of this document being stored within their
                system for the purpose of work finding services."
                    checked={formData.consent} // Use checked for checkboxes
                    onChange={handleChange}
                    isInvalid={!!errors.consent}
                  />
                  {errors.consent && (
                    <Alert variant="danger">{errors.consent}</Alert>
                  )}
                </Form.Group>
                <Button variant="secondary" onClick={prevStep} className="me-2">
                  Previous
                </Button>
                <Button variant="success" type="submit">
                  Submit
                </Button>
              </div>
            )}
          </Form>
        </>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  currentDocument: state.user.currentDocument,
  documentList: state.user.documentList,
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  ipAddress: state.user.ipAddress,
});
export default connect(mapStateToProps, { getSasToken })(LfukKidForPaye);
